<template>
  <el-dialog
    :title="oldFuel.name"
    top="5vh"
    visible
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>Duplicate Fuel Levy</h1>
    <el-form
      ref="duplicateForm"
      v-loading="isSaving"
      :rules="rules"
      :model="newFuel"
      size="small"
    >
      <el-form-item
        label="Name"
        prop="name"
      >
        <el-input
          v-model="newFuel.name"
          placeholder="Fuel Name"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="Start Date"
        prop="date_start"
      >
        <el-date-picker
          v-model="newFuel.date_start"
          type="date"
          format="dd/MM/yyyy"
          placeholder="Pick a Start Date"
          :picker-options="datePickerOption"
          class="w-100"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="End Date"
        prop="date_end"
      >
        <el-date-picker
          v-model="newFuel.date_end"
          type="date"
          format="dd/MM/yyyy"
          placeholder="Pick a End Date"
          :picker-options="datePickerOption"
          class="w-100"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="Group"
        prop="group"
      >
        <el-select
          v-model="newFuel.group"
          placeholder="Unchanged"
          class="w-100"
        >
          <el-option
            label="Unchanged"
            :value="null"
          />
          <el-option
            label="New Group"
            :value="true"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="duplicate"
      >
        Duplicate
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    oldFuel: {
      type: Object,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      newFuel: {},
      isFullscreen: false,
      isSaving: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        name: [
          { required: true, message: 'Name of the Fuel Levy is required', trigger: ['blur', 'change'] },
          { min: 5, max: 45, message: 'Length should be 5 to 45', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.$set(this.newFuel, 'name', this.oldFuel.name)
    this.$set(this.newFuel, 'date_start', new Date())
  },
  methods: {
    duplicate () {
      this.$refs.duplicateForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          const job = new this.$sdk.job()
          job.name = 'bulk.combined'
          job.parameters = {
            model_key: 'fuel',
            duplicate: [
              this.oldFuel.id
            ],
            update: {
              fields: {
                name: this.newFuel.name || '-',
                profile: this.$user.instance.id,
                date_start: this.newFuel.date_start ? this.$moment(this.newFuel.date_start).format('YYYY-MM-DD 00:00:00') : null,
                date_end: this.newFuel.date_end ? this.$moment(this.newFuel.date_end).format('YYYY-MM-DD 00:00:00') : null,
                new_group: this.newFuel.group ? this.newFuel.group : null
              }
            }
          }
          job.create()
            .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
